import React, {useEffect, useState} from 'react';
import { getApi } from "../../../../global/js/api";

const WindowInfo = (props) => {
	const [weatherData, setWeatherData] = useState({});

	useEffect(() => {
		// console.log('weather update...', props.weatherGeo);

		(async () => {
			if(!!props.weatherGeo && !!props.weatherGeo.lat && !!props.weatherGeo.lng) {
				try {
					let url = '';
					// if (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === 'wilson-parking.surge.sh') {
					if (location.hostname === 'wilson-parking.surge.sh') {
						url = `http://www.mocky.io/v2/5d0adb142f00006900e3ed17`;
					} else {
						url = `/api/v2/GetWeather/${props.weatherGeo.lat}/${props.weatherGeo.lng}`;
					}
					let data = await getApi(url);
					if(data && data.weather) {
						// console.log(data.weather);

						renderResults(data);
					}
				} catch (err) {
					console.error(err);
				}
			}
		})();
	}, [props.weatherGeo]);

	const formatDay = (index) => {
		let arr = [
			'Monday',
			'Tuesday',
			'Wednesday',
			'Thursday',
			'Friday',
			'Saturday',
			'Sunday',
		];

		return arr[index - 1];
	}

	const formatMonth = (index) => {
		let arr = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];

		return arr[index];
	}

	const renderResults = (data) => {
		// let imgUrlPrefix = 'http://openweathermap.org/img/w/';
		let temp = data.main.temp - 273.15;
		let imgCode = data.weather[0].icon;
		let today = new Date();
		let day = formatDay(today.getDay());
		let month = formatMonth(today.getMonth());
		let place = data.name;
		let weather = data.weather[0].main;

		setWeatherData({
			temp,
			imgCode,
			today,
			day,
			month,
			place,
			weather
		});
	}

	return (
		<div className="map-weather-info px-3 pointer d-none d-md-block">
			{/* <section className="weather" data-wg="Weather" data-api="http://api.openweathermap.org/data/2.5/weather" data-lat="-37.8493264" data-lon="144.9380054">
			</section> */}
			{
				(!!weatherData.weather) &&
				<div className="weather-wrapper">
					<img className="weather-icon" src={`http://openweathermap.org/img/w/${weatherData.imgCode}.png`} />
					<span className="weather-des">{weatherData.temp.toFixed(0)}° &amp; {weatherData.weather} on {weatherData.day} {weatherData.today.getDate()} {weatherData.month} in {weatherData.place}</span>
				</div>
			}
		</div>

	);
};

export default WindowInfo;
